import { Component, ErrorInfo } from 'react';
import type { ReactNode } from 'react';
import mixpanel from 'mixpanel-browser';
import { getPageSection } from '../lib/analytics';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class AnalyticsErrorBoundary extends Component<Props, State> {
  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, _info: ErrorInfo): void {
    try {
      const pathname =
        typeof window !== 'undefined' ? window.location.pathname : '/';
      mixpanel.track('error_encountered', {
        error_type: 'plugin_crash',
        error_message: error.message,
        page_path: pathname,
        page_section: getPageSection(pathname),
      });
    } catch (_e) {
      // never crash tracking
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" style={{ padding: '1rem' }}>
          Something went wrong while loading this part of the page.
        </div>
      );
    }
    return this.props.children;
  }
}
